module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8691/img/footerCmsFree.png"